import React from "react";
import { SvgIcon } from "@mui/material";
import { styled } from "@mui/material/styles";

const MapsPinIcon = styled(SvgIcon)`
  fill: ${(props) => (props.color ? "currentColor" : "none")};
  stroke: currentcolor;
  stroke-width: 1;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  width: 24px;
  height: 24px;
`;

const MapPinIcon = (props) => (
  <MapsPinIcon {...props}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </MapsPinIcon>
);

export default MapPinIcon;
